/* Maison Virage : petits modules d'aide à la conversion (livraison estimée, compte à rebours réel,
   code promo copiable, barre d'achat collante, ajout groupé des accessoires, texte de collection repliable). */
(function () {
  'use strict';

  /* Livraison estimée en jours ouvrés */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function fmt(d, withMonth) {
    return d.toLocaleDateString('fr-FR', withMonth ? { weekday: 'short', day: 'numeric', month: 'long' } : { weekday: 'short', day: 'numeric' });
  }
  document.querySelectorAll('[data-mv-delivery]').forEach(function (el) {
    var min = parseInt(el.dataset.min, 10) || 7;
    var max = parseInt(el.dataset.max, 10) || 15;
    var now = new Date();
    var a = addBusinessDays(now, min);
    var b = addBusinessDays(now, max);
    var target = el.querySelector('[data-mv-delivery-range]');
    if (!target) return;
    var sameMonth = a.getMonth() === b.getMonth();
    target.textContent = 'entre le ' + fmt(a, !sameMonth) + ' et le ' + fmt(b, true);
  });

  /* Comptes à rebours (uniquement lorsqu'une vraie date de fin est fournie) */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  document.querySelectorAll('[data-mv-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.mvCountdown).getTime();
    var wrap = el.closest('[data-mv-countdown-wrap]') || el;
    if (isNaN(end)) { el.remove(); return; }
    var text = el.querySelector('[data-mv-cd-text]');
    var boxes = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) {
        if (wrap === el) el.remove(); else wrap.remove();
        return false;
      }
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (text) text.textContent = (d > 0 ? d + ' j ' : '') + h + ' h ' + pad(m) + ' min';
      if (boxes.d) { boxes.d.textContent = pad(d); boxes.h.textContent = pad(h); boxes.m.textContent = pad(m); boxes.s.textContent = pad(sec); }
      return true;
    }
    if (tick()) setInterval(tick, 1000);
  });

  /* Code promo copiable */
  document.querySelectorAll('[data-mv-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.dataset.mvCopy;
      var done = function () { btn.classList.add('is-copied'); setTimeout(function () { btn.classList.remove('is-copied'); }, 1600); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    });
  });

  /* Fermeture du bandeau d'annonce (pour la session) */
  var ann = document.querySelector('[data-mv-ann]');
  if (ann) {
    try { if (sessionStorage.getItem('mv-ann-closed') === '1') ann.hidden = true; } catch (e) {}
    var close = ann.querySelector('[data-mv-ann-close]');
    if (close) close.addEventListener('click', function () {
      ann.hidden = true;
      try { sessionStorage.setItem('mv-ann-closed', '1'); } catch (e) {}
    });
  }

  /* Texte de collection repliable sur mobile (« Lire la suite ») */
  document.querySelectorAll('[data-mv-clamp]').forEach(function (el) {
    var btn = el.nextElementSibling;
    if (!btn || !btn.hasAttribute('data-mv-clamp-btn')) return;
    var check = function () {
      if (el.classList.contains('is-open')) return;
      btn.hidden = el.scrollHeight <= el.clientHeight + 4;
    };
    check();
    window.addEventListener('resize', check);
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.textContent = open ? 'Réduire' : 'Lire la suite';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Barre d'achat collante.
     Mobile : visible dès l'arrivée sur la fiche tant que le bouton principal n'est pas à l'écran
     (prix + « Ajouter au panier » visibles sans défiler). Ordinateur : après avoir dépassé le bouton. */
  var submit = document.querySelector('.product__info-container .product-form__submit');
  var bar = document.querySelector('[data-mv-sticky]');
  if (submit && bar && 'IntersectionObserver' in window) {
    bar.hidden = false;
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var priceTarget = bar.querySelector('[data-mv-sticky-price]');
    var btn = bar.querySelector('[data-mv-sticky-btn]');
    var sync = function () {
      var p = document.querySelector('.product__info-container [id^="price-"] .price__container');
      if (p && priceTarget) priceTarget.innerHTML = p.innerHTML;
      var label = submit.querySelector('span');
      if (label && btn) btn.textContent = label.textContent.trim();
      if (btn) btn.disabled = false;
    };
    sync();
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 400); });
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = mqMobile.matches ? !e.isIntersecting : (!e.isIntersecting && e.boundingClientRect.top < 0);
      if (show) sync();
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('mv-sticky-on', show);
    }).observe(submit);
    btn.addEventListener('click', function () {
      if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
        submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      submit.click();
    });
  }

  /* Accessoires à ajouter avec l'appareil */
  document.querySelectorAll('[data-mv-upsell]').forEach(function (box) {
    var checks = box.querySelectorAll('.mv-upsell__check');
    var totalEl = box.querySelector('[data-mv-upsell-total]');
    var countEl = box.querySelector('[data-mv-upsell-count]');
    var addBtn = box.querySelector('[data-mv-upsell-add]');
    var msg = box.querySelector('[data-mv-upsell-msg]');
    var prices = {};
    try { prices = JSON.parse(box.querySelector('[data-mv-variants]').textContent); } catch (e) {}
    var form = document.querySelector('.product__info-container product-form form');
    var money = function (cents) { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); };
    var mainId = function () { var i = form && form.querySelector('input[name="id"]'); return i ? i.value : null; };
    var qty = function () { var q = document.querySelector('.product__info-container input[name="quantity"]'); return q ? Math.max(1, parseInt(q.value, 10) || 1) : 1; };
    function update() {
      var n = 0, total = (prices[mainId()] || 0) * qty();
      checks.forEach(function (c) { if (c.checked) { n++; total += parseInt(c.dataset.price, 10) || 0; } });
      if (countEl) countEl.textContent = n;
      if (totalEl) totalEl.textContent = money(total);
      if (addBtn) addBtn.disabled = n === 0;
    }
    checks.forEach(function (c) { c.addEventListener('change', update); });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects, .product-form__quantity')) setTimeout(update, 400); });
    update();
    addBtn.addEventListener('click', function () {
      var items = [{ id: parseInt(mainId(), 10), quantity: qty() }];
      checks.forEach(function (c) { if (c.checked) items.push({ id: parseInt(c.value, 10), quantity: 1 }); });
      addBtn.disabled = true; addBtn.classList.add('loading'); msg.textContent = '';
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { msg.textContent = res.description || res.message || "L'ajout au panier n'a pas pu se faire. Réessayez."; return; }
        if (drawer && res.sections) {
          drawer.classList.remove('is-empty');
          res.id = items[0].id;
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      }).catch(function () {
        msg.textContent = "L'ajout au panier n'a pas pu se faire. Vérifiez votre connexion puis réessayez.";
      }).finally(function () { addBtn.classList.remove('loading'); update(); });
    });
  });
})();
